<div class="booking-widget-container">
    <p-progressbar *ngIf="loadingStates.page" mode="indeterminate" [style]="{'height': '6px'}" />

    <p-card *ngIf="!loadingStates.page" class="booking-card">
        <p-messages *ngIf="messages.length > 0" [(value)]="messages" [closable]="false" styleClass="w-full mb-3" />

        <p-stepper [value]="1">
            <p-step-item [value]="1">
                <p-step>Membership</p-step>
                <p-step-panel header="Membership">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="grid">
                            <div class="col-12">
                                <label for="membership-discount-code">Membership Discount Code</label>
                                <div class="d-flex align-items-center gap-2">
                                    <span class="p-input-icon-right flex-grow-1">
                                        <input type="text" pInputText [(ngModel)]="validator" 
                                            placeholder="Enter your membership email or discount code"
                                            class="w-100" inputId="membership-discount-code">
                                    </span>
                                    <p-button label="Validate" (onClick)="validateMembershipDiscountCode()" 
                                        [loading]="loadingStates.membershipValidation"
                                        [disabled]="!validator || loadingStates.membershipValidation">
                                    </p-button>
                                    <button pButton pRipple type="button" icon="pi pi-times"
                                        class="p-button-rounded p-button-text" (click)="clearMembershipDiscountCode()">
                                    </button>
                                </div>
                                <div *ngIf="validatedMembership && validatedMembership.status === 200" class="text-success mt-2">
                                    <strong>Membership Validated!</strong><br>
                                    Member: {{validatedMembership.membershipCustomer.firstName}} {{validatedMembership.membershipCustomer.lastName}}<br>
                                    Email: {{validatedMembership.membershipCustomer.emailAddress}}<br>
                                    Discount: {{validatedMembership.membershipCustomer.discountPercent}}% off
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="d-flex justify-content-end">
                                    <p-button label="Next" icon="pi pi-arrow-right" iconPos="right"
                                        (onClick)="activateCallback(2); this.messages = [];"
                                        [disabled]="validatedMembership?.status !== 200">
                                    </p-button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>
            <p-step-item [value]="2">
                <p-step>Time Slot</p-step>
                <p-step-panel header="Time Slot">
                    <ng-template #content let-activateCallback="activateCallback">
                        <div class="grid">
                            <div class="col-12 md:col-6">
                                <label for="date-picker">Date</label>
                                <p-datepicker [(ngModel)]="selectedDate" [showIcon]="true" [showButtonBar]="true"
                                    [readonlyInput]="true" inputId="date-picker" [minDate]="minDate" [maxDate]="maxDate"
                                    styleClass="w-full" (onSelect)="getAvailableTimeSlots()">
                                </p-datepicker>
                            </div>
                            <div class="col-12 md:col-6">
                                <label for="simulator-dropdown">Simulator</label>
                                <p-select [options]="simulators" [(ngModel)]="selectedSimulator" optionLabel="bayName"
                                    [disabled]="!isValid([selectedDate])" placeholder="Select a Sim"
                                    (onChange)="getAvailableTimeSlots()" inputId="simulator-dropdown" styleClass="w-full">
                                </p-select>
                            </div>
                            <div class="col-12 md:col-6">
                                <label for="duration-dropdown">Duration</label>
                                <p-select [options]="[1, 2, 3, 4]" [(ngModel)]="selectedDuration"
                                    placeholder="Select a Duration" (onChange)="getAvailableTimeSlots()"
                                    [disabled]="!isValid([selectedDate, selectedSimulator])" inputId="duration-dropdown"
                                    styleClass="w-full">
                                </p-select>
                            </div>
                            <div class="col-12 md:col-6">
                                <label for="timeslot-dropdown">Time Slot</label>
                                <p-select [options]="availableTimeSlots" [(ngModel)]="selectedTimeSlot"
                                    placeholder="Select a Time Slot" [loading]="loadingStates.timeSlots" styleClass="w-full"
                                    [disabled]="!isValid([selectedDate, selectedSimulator, selectedDuration])"
                                    inputId="timeslot-dropdown">
                                    <ng-template pTemplate="selectedItem" let-selectedOption>
                                        {{selectedOption.startTime | date: 'h:mm a'}} - {{selectedOption.endTime | date:
                                        'h:mm a'}}
                                    </ng-template>
                                    <ng-template let-timeslot pTemplate="item">
                                        {{timeslot.startTime | date: 'h:mm a'}} - {{timeslot.endTime | date: 'h:mm a'}}
                                    </ng-template>
                                </p-select>
                            </div>
                            <div class="col-12">
                                <div class="d-flex justify-content-between">
                                    <p-button label="Back" icon="pi pi-arrow-left" (onClick)="activateCallback(1)" />
                                    <p-button label="Next" icon="pi pi-arrow-right" iconPos="right"
                                        (onClick)="activateCallback(3); this.messages = [];"
                                        [disabled]="!isValid([selectedDate, selectedDuration, selectedSimulator, selectedTimeSlot])">
                                    </p-button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>
            <p-step-item [value]="3">
                <p-step>Information</p-step>
                <p-step-panel header="Information">
                    <ng-template #content let-activateCallback="activateCallback"
                        let-index="index">
                        <div class="container">
                            <div class="row mb-1">
                                <div class="col-12">
                                    <label for="addons">Addons</label>
                                    <p-multiSelect [options]="availableAddons" [(ngModel)]="selectedAddons"
                                        optionLabel="name" placeholder="Select Addons" inputId="addons"
                                        styleClass="full-width">
                                        <ng-template let-addon pTemplate="item">
                                            <div class="flex align-items-center justify-content-between">
                                                <div>{{addon.name}} (${{addon.price}})</div>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-12">
                                    <label for="participants">Number of Golfers</label>
                                    <p-inputNumber [(ngModel)]="participants" [showButtons]="true" inputId="participants"
                                        [min]="0" [max]="6" required class="full-width" />
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-12">
                                    <label for="notes">Notes</label>
                                    <textarea rows="5" cols="30" [(ngModel)]="notes" id="notes" pInputTextarea
                                        [autoResize]="true" class="full-width">
                                    </textarea>
                                </div>
                            </div>
                            <div class="row mt-1">
                                <div class="col-12 d-flex justify-content-between">
                                    <p-button label="Back" icon="pi pi-arrow-left" (onClick)="activateCallback(2)" />
                                    <p-button label="Next" icon="pi pi-arrow-right" iconPos="right"
                                        [loading]="loadingStates.payment"
                                        [disabled]="!isValid([participants]) || loadingStates.payment"
                                        (onClick)="handleNext(activateCallback, 4)" />
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>
            <p-step-item [value]="4">
                <p-step>Payment</p-step>
                <p-step-panel header="Payment">
                    <ng-template pTemplate="content" let-activateCallback="activateCallback" let-index="index">
                        <div class="row">
                            <p-progressBar *ngIf="loadingStates.payment" mode="indeterminate" [style]="{'height': '6px'}" />
                        </div>
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="font-bold">Total Amount:</span>
                                    <span class="font-bold">${{totalPrice.toFixed(2)}}</span>
                                </div>
                                <div *ngIf="validatedMembership" class="text-success mt-1">
                                    <small>Membership discount applied: {{validatedMembership.membershipCustomer.discountPercent}}% off</small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                @if (elementsOptions.clientSecret){
                                <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
                                    <ngx-stripe-payment [options]="paymentElementsOptions" (change)="onCardChange($event)" />
                                </ngx-stripe-elements>
                                }
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div class="col-12 d-flex justify-content-between">
                                <p-button label="Back" icon="pi pi-arrow-left"
                                    (onClick)="handleCancelPaymentBack(activateCallback, 3)" />
                                <p-button label="Submit" icon="pi pi-arrow-right" iconPos="right"
                                    [loading]="loadingStates.submission" [disabled]="loadingStates.submission || !isCardValid"
                                    (onClick)="submit()" />
                            </div>
                        </div>
                    </ng-template>
                </p-step-panel>
            </p-step-item>
        </p-stepper>
    </p-card>
</div>
